module.exports = __webpack_public_path__ + "img/pb-consig.c28c5a16.png";